import type Page from '../../../../js/common/types/api/page'
import { ContentBlockGallery, WidgetGallery } from '../../../../js/common/types/api/page'

export function getNextId(page: Page): number {
    return (
        Math.max(
            page.blocksHtml.reduce((s, { id }) => Math.max(s, id), 1),
            page.blocksPipes.reduce((s, { id }) => Math.max(s, id), 1),
            page.galleries.reduce((s, { id }) => Math.max(s, id), 1)
        ) + 1
    )
}

export function getNextIdWidgetGallery(columns: (WidgetGallery | ContentBlockGallery)[][]): number {
    return (columns
        .map(col => {
            return col.reduce((s, { id }) => Math.max(s, id), 1)
        })
        .reduce((s, id) => Math.max(s, id), 1)) + 1
}
